import { z } from 'zod';
export const paginationQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
/** Standard error codes used across services. */
export const ErrorCode = {
    Validation: 'VALIDATION_ERROR',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    Conflict: 'CONFLICT',
    RateLimited: 'RATE_LIMITED',
    QuotaExceeded: 'QUOTA_EXCEEDED',
    Internal: 'INTERNAL_ERROR',
};
//# sourceMappingURL=common.js.map